import { api, createCancelTokenHandler } from '../../vodea/services';

const endPoint = () => process.env.REACT_APP_PASSPORT_END_POINT;

const Repository = {
  all: function (vendorId: number | string, params: any = null) {
    return api.get(`${endPoint()}/api/vendor/${vendorId}/role`, {
      params,
      cancelToken: cancelTokenHandlerObject[this.all.name].handleRequestCancellation().token
    });
  },
  show: function (vendorId: number | string, id: number | string, params: any = null) {
    return api.get(`${endPoint()}/api/vendor/${vendorId}/role/${id}`, {
      params,
      cancelToken: cancelTokenHandlerObject[this.show.name].handleRequestCancellation().token
    });
  },
  create: function (vendorId: number | string, payload: any, params: any = null) {
    return api.post(`${endPoint()}/api/vendor/${vendorId}/role`, payload, {
      params,
      cancelToken: cancelTokenHandlerObject[this.create.name].handleRequestCancellation().token
    });
  },
  update: function (vendorId: number | string, id: number | string, payload: any, params: any = null) {
    return api.put(`${endPoint()}/api/vendor/${vendorId}/role/${id}`, payload, {
      params,
      cancelToken: cancelTokenHandlerObject[this.update.name].handleRequestCancellation().token
    });
  },
  delete: function (vendorId: number | string, id: number | string, params: any = null) {
    return api.delete(`${endPoint()}/api/vendor/${vendorId}/role/${id}`, {
      params,
      cancelToken: cancelTokenHandlerObject[this.delete.name].handleRequestCancellation().token
    });
  }
};

export default Repository;

const cancelTokenHandlerObject = createCancelTokenHandler(Repository);
